.be{flex-shrink:0;}